const outcomes = ['CREATED', 'SKIPPED', 'FAILED', 'NOT_PROCESSED'];
const isObject = value => value && typeof value === 'object' && !Array.isArray(value);
const optionalMoney = value => value == null || (typeof value === 'number' && Number.isFinite(value));

// Rozpoznajemy tylko kompletny, wersjonowany kontrakt. Starszy backend/log nadal
// korzysta ze swojego dotychczasowego widoku, zamiast wyświetlać mylące zera.
export function parseGenerationReport(value) {
  let report = value;
  if (typeof value === 'string') {
    try { report = JSON.parse(value); } catch (e) { return null; }
  }
  if (!isObject(report) || report.version !== 1 || typeof report.runId !== 'string'
    || !['COMPLETED', 'FAILED'].includes(report.status)
    || !isObject(report.request) || !isObject(report.scope) || !isObject(report.threshold)
    || !isObject(report.summary) || !isObject(report.persistence)
    || !Array.isArray(report.drivers) || !Array.isArray(report.warnings)
    || !Array.isArray(report.request.subCompanyIds)
    || !report.request.subCompanyIds.every(id => typeof id === 'string')
    || typeof report.request.startDate !== 'string' || typeof report.request.endDate !== 'string'
    || typeof report.request.search !== 'string'
    || typeof report.request.onDemand !== 'boolean'
    || typeof report.persistence.saved !== 'boolean'
    || typeof report.scope.candidatesKnown !== 'boolean'
    || !Number.isInteger(report.scope.candidateCount) || report.scope.candidateCount < 0
    || report.scope.pool !== 'POSITIVE_TOTAL' || report.threshold.comparison !== 'GT'
    || !(report.threshold.amountCents === null || (typeof report.threshold.amountCents === 'number' && Number.isFinite(report.threshold.amountCents)))
    || !['created', 'skipped', 'failed', 'notProcessed'].every(key => Number.isInteger(report.summary[key]) && report.summary[key] >= 0)
    || !report.drivers.every(row => isObject(row) && typeof row.driverId === 'string'
      && typeof row.name === 'string' && typeof row.message === 'string' && outcomes.includes(row.outcome)
      && ['totalCents', 'payoutCents', 'actualCents', 'requiredCents'].every(key => optionalMoney(row[key])))
    || !report.warnings.every(warning => isObject(warning) && typeof warning.message === 'string')
    || (report.fees && (!isObject(report.fees) || typeof report.fees.completed !== 'boolean' || !Array.isArray(report.fees.charged)
      || !report.fees.charged.every(row => isObject(row) && typeof row.driverId === 'string' && typeof row.name === 'string' && optionalMoney(row.amountCents))))) return null;
  const counted = { CREATED: 0, SKIPPED: 0, FAILED: 0, NOT_PROCESSED: 0 };
  report.drivers.forEach(row => counted[row.outcome]++);
  if (report.summary.created !== counted.CREATED || report.summary.skipped !== counted.SKIPPED
    || report.summary.failed !== counted.FAILED || report.summary.notProcessed !== counted.NOT_PROCESSED
    || (report.scope.candidatesKnown && report.scope.candidateCount !== report.drivers.length)
    || (report.status === 'COMPLETED' && (counted.FAILED || counted.NOT_PROCESSED))) return null;
  return report;
}

export function generationSummary(report, translate) {
  return translate('generationReport.summary', report.summary);
}

export function formatReportMoney(cents, locale = 'pl') {
  if (typeof cents !== 'number' || !Number.isFinite(cents)) return '—';
  return new Intl.NumberFormat(locale === 'en' ? 'en-GB' : 'pl-PL', { style: 'currency', currency: 'PLN' }).format(cents / 100);
}
